import { render, staticRenderFns } from "./ItineraryData.vue?vue&type=template&id=35780a6a&"
import script from "./ItineraryData.vue?vue&type=script&lang=js&"
export * from "./ItineraryData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports